import React from 'react';
import './Education.css';

function Education() {
  const courses = [
    'Object Oriented Programming', 'Databases', 'Discrete Mathematics',
    'Data Structures & Algorithms', 'Operating Systems', 'Computer Networks',
    'Machine Learning', 'Data Mining', 'Advanced DSA',
    'Information Retrieval', 'Image Processing'
  ];

  return (
    <section id="education" className="education">
      <div className="container">
        <h2 className="section-title reveal">Education</h2>
        <p className="section-subtitle reveal">
          Building a strong foundation in computer science
        </p>
        
        <div className="education-card reveal">
          <div className="edu-icon-wrapper">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
              <path d="M6 12v5c0 0 3 3 6 3s6-3 6-3v-5"></path>
            </svg>
          </div>

          <div className="edu-content">
            <div className="education-header">
              <div>
                <h3>Acharya Institute of Technology</h3>
                <p className="degree">B.E. in Information Science and Technology</p>
              </div>
              <div className="edu-meta">
                <span className="duration-badge">Aug 2017 — Aug 2021</span>
                <span className="cgpa-badge">CGPA: 8.04 / 10</span>
              </div>
            </div>
            
            <div className="coursework">
              <h4>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                  <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                </svg>
                Relevant Coursework
              </h4>
              <div className="course-list">
                {courses.map((course, idx) => (
                  <span key={idx} className="course">{course}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Education;
